import { apiClient, handleApiError, isBackendEnabled } from '../client';
import { PersonaRecommendationProduct } from '../types';

/**
 * Recommendation API Service
 * Fetches persona-based product recommendations
 */
export const recommendationApi = {
    /**
     * Get product recommendations for a persona by ID
     * GET /recommendation/persona/:personaId
     */
    getRecommendationsByPersona: async (personaId: string): Promise<PersonaRecommendationProduct[]> => {
        if (!isBackendEnabled() || !apiClient) {
            return [];
        }

        try {
            const response = await apiClient.get<PersonaRecommendationProduct[]>(
                `/recommendation/persona/${encodeURIComponent(personaId)}`
            );
            return Array.isArray(response.data) ? response.data : [];
        } catch (error) {
            throw handleApiError(error);
        }
    },
};
